import { add, eachDayOfInterval, startOfWeek } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import SwiperCore from "swiper";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import MenuView from "./MenuView";

SwiperCore.use([Autoplay]);

function MenuWeek(props) {
  const match = useParams<{ week?: string }>();

  let startDate = startOfWeek(new Date());

  if (match.week === "next-week") {
    startDate = startOfWeek(add(new Date(), { days: 6 }));
  }

  startDate = add(startDate, { days: 1 });
  const endDate = add(startDate, { days: 6 });

  return (
    <React.Fragment>
      <Swiper
        autoplay={{
          delay: 10 * 1000,
        }}
        loop
      >
        {eachDayOfInterval({
          start: startDate,
          end: endDate,
        }).map((d) => {
          return (
            <SwiperSlide key={d.getDate()}>
              <div className="view">
                <MenuView date={d} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </React.Fragment>
  );
}

export default MenuWeek;
